import request from "@/untils/request.js";
//获取直播详情
export function getLiveInfo(query) {
  return request({
    url: "/live/get-anchor-live-info",
    method: "get",
    params: query,
  });
}
//用户直播间权限详情
export function userPowerLive(query) {
  return request({
    url: "/live/get-user-room-base",
    method: "get",
    params: query,
  });
}
////获取平台助理列表
export function anchorAssistantList(query) {
  return request({
    url: "/member/user/list-aide",
    method: "get",
    params: query,
  });
}
